<script>
import Layout from "../../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { utilityService } from "../../../../../services/managements/utilities/utility.service";
import List from "../../../../../components/list";
import Screen from "../../../../../components/screen";
import i18n from "../../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
    extends:Screen,
    page: {
        title: "Utilities List",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader, List },
    data() {
        return {
        data: {},
        fetchingStats: false,
        title: "Utilities List",

        };
    },
    mounted() {
        
        this.loadingData();
    },

    methods: {
        loadingData: function(param = '') {
        this.fetchingStats = false;
            utilityService.getList(param)
                .then(response => {
                
                this.fetchingStats = true;
                this.data = response;
            });
        },

        deleted: function(id) {
            utilityService.remove(id)
                .then(response => {
                // this.customerData = response;
                if(response.status == 200) {
                    this.$swal.fire({
                    title: i18n.t('general.confirm.deleted'),
                    text: i18n.t('general.confirm.success'),
                    icon: "success",
                    confirmButtonText: i18n.t('general.ok')
                    });
                }
            });
        },

        pageNavigate: function(param) {
        this.loadingData(param);
        },

        submitAdd: function() {
        this.$router.push(this.$route.query.redirectFrom || {
                name: "manage-setting-utility-add",
            });
        },

    }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'manage-setting-utility-add'}" :title="$t('manage.utility.text')" />
    <List v-bind:dataList="data" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
           v-bind:formats="[{name: 'price', type: 'currency'}]"
          v-bind:fields="[ 
            `project_name: ${$t('project.text')}`,
            `name: ${$t('manage.service.name')}`,
            `name_en: ${$t('manage.name_en')}`,
            `price: ${$t('manage.utility.price')}`,
          ]"
          v-bind:edit="{link: 'manage-setting-utility-edit'}"
          v-bind:filter="{
            search: ['mg_utilities.name','mg_utilities.name_en']
          }"
          
    />      
  </Layout>
</template>